export default "__VITE_ASSET__04f5b74a__"